import React, { useState, useEffect } from 'react'

import DispatcherService from '../services/DispatcherService'
import Wizard from './main/Wizard'
import Loading from './main/Loading'
import Error from './main/Error'

import Signup from './signup/Signup'

function App() {
  const [ loading, setLoading ] = useState(true)
  const [ error, setError ] = useState(false)
  const [ invite, setInvite ] = useState(null)

  const loadInvite = async () => {
    try {
      setLoading(true)
      const invite = await DispatcherService.loadInvite()
      setInvite(invite)
      setError(false)
    } catch (error) {
      console.error('Falhou ao carregar o convite. Motivo: ', error)
      setError(error)
    }
    setLoading(false)
  } 

  const tryAgain = async () => {
    setError(false)
    await loadInvite()
  }

  const isConfirmationRoute = window.location.pathname.indexOf('/web-client/sign-up/confirm') === 0 
    && DispatcherService.getReqId() 
    && DispatcherService.getEmailFromURL()
  
  useEffect(() => {
    if (!isConfirmationRoute) {
      loadInvite()
    }
  }, [ isConfirmationRoute ])

  if (isConfirmationRoute) { 
    return <Signup />
  }

  if (error) {
    return <Error statusCode={error.statusCode} onTryAgain={tryAgain} />
  }
  
  if (loading) {
    return <Loading />
  }

  return <Wizard invite={invite} />
}

export default App;
